"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.retryUnauthorizedHandler = void 0;
var tslib_1 = require("tslib");
var get_1 = tslib_1.__importDefault(require("lodash/get"));
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var set_1 = tslib_1.__importDefault(require("lodash/set"));
var jwt_handler_1 = require("../jwt-handler");
var type_checker_1 = require("../type-checker");
var axios_instance_1 = require("./axios-instance");
var exchange_refresh_token_1 = require("./exchange-refresh-token");
var retryUnauthorizedHandler = function (err) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var retryDelay, config, response, _a, max, count, token, retry, refreshedTokenPayload, retryConfig_1;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                retryDelay = 500;
                config = err.config, response = err.response;
                _a = (0, get_1.default)(config, '_retry', { max: 1, count: 0 }), max = _a.max, count = _a.count;
                token = jwt_handler_1.JWTHandler.getCookie('rentspreeUserToken');
                if ((0, isEmpty_1.default)(token)) {
                    return [2, Promise.resolve()];
                }
                if (!(config && !(0, type_checker_1.isTokenRequest)(config.url) && (0, get_1.default)(response, 'status', 0) === 401 && count < max)) return [3, 2];
                retry = { max: max, count: count + 1 };
                (0, set_1.default)(config, '_retry', retry);
                return [4, (0, exchange_refresh_token_1.exchangeRefreshToken)()];
            case 1:
                refreshedTokenPayload = _b.sent();
                if ((0, isEmpty_1.default)(refreshedTokenPayload) && (0, isEmpty_1.default)(refreshedTokenPayload.access_token)) {
                    return [2, Promise.reject(err)];
                }
                jwt_handler_1.JWTHandler.setCookie('rentspreeUserToken', refreshedTokenPayload, {
                    expires: 'session',
                    path: '/',
                    domain: window.location.hostname.split('.').slice(1).join('.'),
                });
                retryConfig_1 = tslib_1.__assign(tslib_1.__assign({}, config), { headers: { Authorization: "Bearer ".concat(refreshedTokenPayload.access_token) } });
                return [2, new Promise(function (resolve) { return setTimeout(function () { return resolve(axios_instance_1.axios.request(retryConfig_1)); }, retryDelay); })];
            case 2: return [2, Promise.reject(err)];
        }
    });
}); };
exports.retryUnauthorizedHandler = retryUnauthorizedHandler;
//# sourceMappingURL=retry-unauthorized-handler.js.map